
import {Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges}      from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {HttpParams} from "@angular/common/http";
import * as moment from 'moment';
import {UsageFilter} from "../usage/usage.filter";

@Component({
  selector: 'micro-ussd-dashboard',
  templateUrl: './ussd-dashboard.component.html'
})
export class UssdDashboardComponent implements OnInit {

  filter:UsageFilter = new UsageFilter();
  settings:any;

  constructor(
    private env: EnvService,
    private http:HttpClient
  ) {}

  allCharts:any[] = [
    {
      entityType: 'USSD_SESSION',
      groupBy: 'status',
      dateField: 'modifiedDate',
      filter: '',
      title: 'USSD Session Status'
    },
    {
      entityType: 'USSD_SESSION',
      groupBy: 'networkName',
      dateField: 'modifiedDate',
      filter: '',
      title: 'USSD Session Networks'
    },
    {
      entityType: 'USSD_SESSION_LOG',
      groupBy: 'rspStatus',
      dateField: 'datetime',
      filter: '',
      title: 'USSD Session Logs'
    },
    {
      entityType: 'USSD_SESSION_LOG',
      groupBy: 'reqCode',
      dateField: 'datetime',
      filter: '',
      title: 'USSD Session Logs'
    }
  ];

  ngOnInit() {
    this.loadSettings();
  }

  loadSettings() {
    var strSettings = localStorage.getItem('ussdSessionDashboards_settings');
    if (!strSettings) {
      this.settings = {
        autoRefresh: false
      }
      this.saveSettings();
    }
    this.settings = JSON.parse(localStorage.getItem('ussdSessionDashboards_settings'))
  }

  saveSettings() {
    localStorage.setItem('ussdSessionDashboards_settings', JSON.stringify(this.settings));
  }
}
